const pending = new Set();
const listeners = new Set();
let nextId = 0;
const publish = () => listeners.forEach((listener) => listener());
export const subscribeRequestLoading = (listener) => { listeners.add(listener); return () => listeners.delete(listener); };
export const getPendingRequestCount = () => pending.size;

export const beginRequestLoading = () => {
  const id = ++nextId;
  pending.add(id);
  publish();
  return () => { if (pending.delete(id)) publish(); };
};

export const installRequestLoading = (client) => {
  const ids = new Set();
  const finish = (config) => {
    const id = config?.__beautiLoadingId;
    if (!ids.delete(id)) return;
    pending.delete(id);
    publish();
  };
  const requestId = client.interceptors.request.use((config) => {
    if (config.silent === true) return config;
    config.__beautiLoadingId = ++nextId;
    ids.add(config.__beautiLoadingId);
    pending.add(config.__beautiLoadingId);
    publish();
    return config;
  });
  const responseId = client.interceptors.response.use((response) => {
    finish(response.config);
    return response;
  }, (error) => {
    finish(error.config);
    return Promise.reject(error);
  });
  return () => {
    client.interceptors.request.eject(requestId);
    client.interceptors.response.eject(responseId);
    ids.forEach((id) => pending.delete(id));
    ids.clear();
    publish();
  };
};
